import {
    ComponentParams,
    ComponentRendering,
    useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import GenericHeader, { GenericHeaderProps } from "components/ui/GenericHeader";
import CarouselPlaceholder, { CountItems } from "components/ui/Carousel/CarouselPlaceholder";
import QuoteElement from "./QuoteElement";

export type QuoteProps = {
    rendering: ComponentRendering & { params: ComponentParams };
    params: { [key: string]: string };
    fields: GenericHeaderProps;
};

const Quote = (props: QuoteProps) => {
    const {
        sitecoreContext: { pageEditing },
    } = useSitecoreContext();

    const phKey = `Quote-${props.params.DynamicPlaceholderId}`;
    const slides = props.rendering.placeholders
        ? Object.values(props.rendering.placeholders)[0]
        : [];
    const scSlidesLength = CountItems(slides);
    const placeholderOptions =
        slides.length > 1
            ? {
                  quoteLength: slides.length + "",
              }
            : undefined;

    return (
        <GenericHeader
            Id={props.rendering?.uid}
            HeaderHeadline={props.fields?.HeaderHeadline}
            HeaderSubHeadline={props.fields?.HeaderSubHeadline}
            HeaderCTA={props.fields?.HeaderCTA}
            headlineSize={props.params?.HeaderHeadlineSize}
        >
            <CarouselPlaceholder
                phkey={phKey}
                componentsProps={props.rendering}
                carouselProps={{
                    id: "quoteCarousel",
                    gap: 0,
                    slidesToShow: [1],
                    dots: true,
                    sx: {
                        alignItems: "center",
                        p: 1,
                    },
                }}
                carouselEditProps={{
                    width: `calc(100% * ${scSlidesLength})`,
                }}
                placeholderParams={placeholderOptions}
            >
                {!pageEditing &&
                    slides.map((slide: any) => {
                        return (
                            <QuoteElement
                                key={slide.uid}
                                {...slide}
                                params={{
                                    ...slide.params,
                                    quoteLength: scSlidesLength > 1 && scSlidesLength,
                                }}
                            />
                        );
                    })}
            </CarouselPlaceholder>
        </GenericHeader>
    );
};
export default Quote;
